import React, { useState } from 'react';
import { Modal, Fade, Backdrop } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { isMobile } from 'react-device-detect';
import ButtonBase from '../Buttons/ButtonBase';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import ChipInput from 'material-ui-chip-input';
import axios from 'axios';

//https://github.com/TeamWertarbyte/material-ui-chip-input#readme

const useStyles = makeStyles({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    width: 560,
    height: 456,
    borderRadius: 4,
    padding: 24,
    margin: 0,
    boxShadow: '0 15px 15px 0 rgba(0, 40, 62, 0.3)',
    backgroundColor: 'white',
    position: 'relative',
    '&:focus': {
      outline: 'none',
    },
    '@media(max-width: 592px)': {
      width: 328,
      height: 'auto',
    },
  },
  closeIcon: {
    width: 24,
    height: 24,
    position: 'absolute',
    top: 0,
    right: 0,
    margin: 24,
    cursor: 'pointer',
    '@media(max-width: 592px)': {
      margin: 16,
    },
  },
  formContent: {
    maxWidth: 368,
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    '@media(max-width: 592px)': {
      maxWidth: 286,
    },
  },
  infoWrapper: {
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    height: '100%',
  },
  name: {
    fontSize: 28,
    color: '#10587f',
    textAlign: 'center',
    marginTop: 40,
    marginBottom: 22,
    fontWeight: 'bold',
    '@media(max-width: 592px)': {
      fontSize: 22,
      marginTop: 24,
    },
  },
  subname: {
    fontSize: 16,
    color: '#484848',
    textAlign: 'center',
    margin: '0 0 29px 0',
    maxWidth: 350,
    '@media(max-width: 592px)': {
      maxWidth: 208,
    },
  },
  email: {
    width: 367,
    height: 48,
    backgroundColor: '#f5f5f5',
    display: 'flex',
    alignItems: 'center',
    padding: '0 16px',
    marginTop: 19,
    '@media(max-width: 592px)': {
      width: 264,
    },
  },
  buttons: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    marginTop: 60,
    marginBottom: 20,
    '@media(max-width: 592px)': {
      marginBottom: 0,
    },
  },
  ButtonBase: {
    minWidth: '160px !important',
    width: 'initial',
    '@media(max-width: 592px)': {
      minWidth: '128px !important',
    },
  },
  buttonCancel: {
    marginRight: 24,
  },
  TextField: {
    maxWidth: 369,
    '@media(max-width: 592px)': {
      maxWidth: 264,
    },
  },
  text: {
    fontSize: 12,
    borderTop: '1px solid #e7e7e7',
    maxWidth: 369,
    padding: '8px 20px 50px',
    textAlign: 'center',
    '@media(max-width: 592px)': {
      padding: '8px 20px 30px',
    },
  },
  helperText: {
    marginLeft: 0
  },
  chip: {
    '&$focused': {
      backgroundColor: '#01395',
    }
  }
});

function SendInvoice(props) {
const {
  open,
  handleClose,
  primaryFunction,
  lawyerEmail,
  invoiceToSend,
}= props;
  const [chips, setChips] = useState([]);

  const classes = useStyles();

  const closeModal = (event) => {
    event.preventDefault();
    handleClose();
  };

  const formSendInvoice = {
    emails: [],
  };

  const handleAddChip = (chip, setFieldValue) => {
    let newChips = [...chips];
    newChips.push(chip)
    console.log('adding', newChips)
    setChips(newChips);
    setFieldValue('emails', newChips)
  }

  const handleDeleteChip = (chip, index) => {
    let newChips = [...chips];
    newChips.splice(index, 1)
    //console.log('deleting', newChips)
    setChips(newChips);
  }
  const handleSubmitForm = (values, { setSubmitting, setFieldError,setFieldValue }) => {
    console.log(values.emails)
    console.log('invoiceToSend', invoiceToSend)
       axios.get(`${process.env.REACT_APP_FIREBASE_URLSERVICE_PAYMENT}/invoices/send_invoice_mail?idInvoice=${invoiceToSend}`, {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          'Authorization': `Bearer ${'TgC1n73rN37Gr0u9'}`
          },
     },{"email": values.emails}).then(res=>{
        console.log('res',res)
        handleClose()
       return res
     })
     .catch(err=>{
      return err 
   })
  }


  const handleRenderSendInvoiceForm = (props) => {
    const {
      handleChange,
      handleSubmit,
      values,
      setFieldValue,
      touched,
      errors,
      handleBlur,
      isValid,
    } = props;

   

    return (
      <form className={classes.formContent}  >

        <ChipInput
          id="emails"
          name="emails"
          value={chips}
          label="Añadir otro correo electrónico"
          onAdd={(chip) =>{ handleAddChip(chip, setFieldValue)}}
          onDelete={(chip, index) => handleDeleteChip(chip, index)}
          variant="outlined"
          classes={{ root: classes.TextField, helperText: classes.helperText, chip: classes.chip }}
          blurBehavior='clear'
          helperText={'Separa los correos por una coma (,)'}
          newChipKeyCodes = { [188, 32] } //comma & space keys
          onBeforeAdd ={ (chip) => chip.match(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/)? true:false} //validate if chip has email format  
        />

        <div className={classes.email}>{lawyerEmail}</div>

        <div className={classes.buttons}>
          <ButtonBase
            onClick={closeModal}
            variant="primaryOutlined"
            className={`${classes.ButtonBase} ${classes.buttonCancel}`}
          >
            Cancelar
          </ButtonBase>

          <ButtonBase
            type="submit"
            onClick={handleSubmit}
            variant="primary"
            className={classes.ButtonBase}
          >
            Enviar
          </ButtonBase>
        </div>
      </form>
    );
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <div className={classes.paper}>
          <img
            src="/img/icons/close.svg"
            alt="cerrar mensaje"
            className={classes.closeIcon}
            onClick={handleClose}
          />
          <div className={classes.infoWrapper}>
            <div>
              <p className={classes.name}>Enviar factura por correo</p>
            </div>

            <div className={classes.subname}>
              <span>La factura de <b>{invoiceToSend}</b> se enviará al o los correos:</span>
            </div>

            <Formik
              initialValues={formSendInvoice}
              onSubmit={handleSubmitForm}
              render={handleRenderSendInvoiceForm}
            />
          </div>
        </div>
      </Fade>
    </Modal>
  );
}

const mapDispatchToProps = (dispatch) => ({});

const mapStateToProps = (state) => ({
  laywerUid: state.authClient.uid,
  lawyerEmail: state.authClient.email,
});

export default connect(mapStateToProps, mapDispatchToProps)(SendInvoice);
